var site = site || {};

site.customerService = site.customerService || (function ($) {
  var currentURL;

  function initializeValues() {
    currentURL = document.URL;
  }

  function bindEvents() {
    // When a menu link is clicked, toggle its submenu.
    $('.customer-service-menu .menu__link--lvl-1').on('click', toggleSubmenu).attr('aria-expanded', 'false');
    // When a subsection title is clicked, toggle its content.
    $('.customer-service-section').find(':header').on('click', toggleSubsection);
    // When a submenu title is clicked, toggle its content.
    $('.customer-service-menu .menu__link--lvl-2').on('click', toggleSubsectionFromMenu);
  }

  // Based upon the distinct URL, reveal the correct submenu in the side menu on page load.
  // The side menu has not been customized, so the submenus are just referenced by child number.
  function loadSubmenu() {
    if (currentURL.indexOf('customer-service-orders') > -1) {
      $('.customer-service-menu .menu__list li:nth-child(1)').addClass('active-submenu');
    } else if (currentURL.indexOf('customer-service-returns') > -1) {
      $('.customer-service-menu .menu__list li:nth-child(2)').addClass('active-submenu');
    } else if (currentURL.indexOf('customer-service-shipping') > -1) {
      $('.customer-service-menu .menu__list li:nth-child(3)').addClass('active-submenu');
    }/* else if (currentURL.indexOf('customer-service-new-to-bobbi') > -1) {
      $('.customer-service-menu .menu__list li:nth-child(4)').addClass('active-submenu');
    }*/ else if (currentURL.indexOf('customer-service-account') > -1) {
      $('.customer-service-menu .menu__list li:nth-child(4)').addClass('active-submenu');
    } else if (currentURL.indexOf('customer-service-corporate') > -1) {
      $('.customer-service-menu .menu__list li:nth-child(5)').addClass('active-submenu');
    } else if (currentURL.indexOf('customer-service-faqs') > -1) {
      $('.customer-service-menu .menu__list li:nth-child(6)').addClass('active-submenu');
    } else {
      $('.customer-service-quick-info').hide();
    }
  }

  // Check URL for specific #id, and open up that subsection content.
  function loadSubsection() {
    var subsectionID = currentURL.substr(currentURL.indexOf('#'));
    var subsectionContentID;

    if (subsectionID !== '#') {
      subsectionContentID = subsectionID + '-content';
      $(subsectionID).addClass('active-subsection');
      $(subsectionContentID).addClass('active-subsection');
    }
    if (subsectionID == '#textoptout') {
      $('#corporate-privacy-content').addClass('active-subsection');
    }
    if (subsectionID == '#targeted-advertising') {
      $('#corporate-privacy-content').addClass('active-subsection');
    }
    if (Drupal.settings.gdpr_compliant) {
      if (subsectionID === '#5' || subsectionID === '#1b' || subsectionID === '#1a3') {
        $('#corporate-privacy-content').addClass('active-subsection');
      }
    }
  }

  // Check URL for #textoptout, and open up that parent subsection content.
  function loadTextOptOut() {
  }

  // When a menu topic is clicked, reveal (or hide) the submenu.
  function toggleSubmenu() {
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true').parent().toggleClass('active-submenu');
  }

  // When a subsection header is clicked, reveal (or hide) the subsection content.
  function toggleSubsection() {
    $(this).toggleClass('active-submenu').attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
    var contentSectionID = '#' + $(this).attr('id') + '-content';

    $(contentSectionID).toggleClass('active-subsection');
  }

  // Different version of the toggleContentSection that triggers when a menu item
  // is clicked that DOES NOT go to a different page.
  function toggleSubsectionFromMenu() {
    var subsectionID = $(this).attr('href').substr($(this).attr('href').indexOf('#')); // Grab the id in the link href
    var subsectionContentID = subsectionID + '-content';

    $(subsectionID).toggleClass('active-subsection');
    $(subsectionContentID).toggleClass('active-subsection');
  }

  return {
    init: function () {
      initializeValues();
      loadSubmenu();
      loadSubsection();
      bindEvents();
    }
  };
})(jQuery);

jQuery(document).ready(function () {
  site.customerService.init();
});
